import { useCampaignPlansQuery } from "../../networking/queries"

const useGetSubOfferingCampaignPlan = () => {
  const { data: campaignPlans } = useCampaignPlansQuery()
  const campaignPlan = campaignPlans?.[0]

  return (
    campaignPlan || {
      campaign: undefined,
      trial_length_key: "7",
      price_info: {
        unit_amount: 8999,
      },
    }
  )
}

export default useGetSubOfferingCampaignPlan
